var simulateClick = {};

{ // Fiche produit
	// Affichage de la selection des tailles des produits de la couleur choisie
	$(document).on('click', 'input[type="radio"][class="custom-control-input"]', function(){
		var blocktodisplay = $('.size-selector');
		blocktodisplay.fadeIn('quick');

		var todisplay = document.getElementsByClassName("product-line");
		var colorToCompare = this.getAttribute("data-color");
		Array.prototype.forEach.call(todisplay, function(el) {
			let color = el.getAttribute("data-attr-color");
			if (colorToCompare == color ) {
				$(el).fadeIn('slow');
			}else{
				$(el).hide();
			}
		});
		return;
	});

	// simule un clic sur l'image d'un produit enfant / slick
	$(document).on('click', 'input[type="radio"][class="custom-control-input"]', function(){

    var slidelist = document.getElementsByClassName("single-product-slider-nav__image");
    if( slidelist.length == 0 ){
      slidelist = document.getElementsByClassName("horizontal-slider-nav__single-slide");
    }

    var selectedColor = this.getAttribute('data-img-id');

		Array.prototype.forEach.call(slidelist, function(slide){
      let child = slide.getAttribute("data-img-id");
    	if(child == selectedColor){
				simulateClick(selectedColor);
			}
		});
	});

  /** Cette fonction permet de simules le click sur le slider d'images.
	 * 	Utiliser pour allez sur l'image du produit correspondant à la couleur choisie.
	 * 	@param { int } identifiant de l'enfant correspondant à la couleur
	 * 	@return void
	 */
	simulateClick = function (color) {
		var event = new MouseEvent('click', {
			'view': window,
			'bubbles': true,
			'cancelable': true
    });

    var toSelect = document.querySelectorAll('[data-img-id="' + color + '"]')[0];
    toSelect.dispatchEvent(event);
	}
}
